import React from "react";
import { PrimaryButton } from "../Base/Button";
import { Box } from "@mui/material";
import SkipButton from "./SkipButton";

const SubmitButton = ({
  hasNote,
  form,
  component,
  disabled,
  skip,
  skipHandler,
  displayVal = "",
  repaymentBtn = "",
  panBtn = "",
}) => {
  const buttons = {
    No: (
      <Box
        className="submitButton_Th"
        sx={{
          position:
            repaymentBtn === "RepaymentBtn"
              ? "relative"
              : panBtn === "PanBTN"
              ? "relative"
              : "fixed",
          top: "92.5%",
          left: "50%",
          marginTop:
            repaymentBtn === "RepaymentBtn"
              ? "-30px"
              : panBtn === "PanBTN"
              ? "70px"
              : "0px",
          // maxWidth: "400px",
          maxWidth: "200px",
          width: "calc(100% )",
          padding:
            repaymentBtn === "RepaymentBtn"
              ? "0px"
              : panBtn === "PanBTN"
              ? "0px"
              : "0 16px",
          transform: "translate(-50%, -50%)",
          zIndex: 1000,
          textTransform: "uppercase",
          // backgroundColor: "white",
          // "#363333",
        }}
      >
        <PrimaryButton
          form={form && form}
          type="submit"
          disabled={disabled && disabled}
          displayVal={displayVal}
        />
      </Box>
    ),
    Yes: (
      <Box
        sx={{
          position: "fixed",
          display: "flex",
          justifyContent: "flex-start",
          flexDirection: "column",
          top: "93%",
          left: "50%",
          width: "90%",
          // transform: "translate(-50%, -50%)",

          background: "white",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "flex-start" }}>
          {component}
        </Box>
        <PrimaryButton
          type="submit"
          form={form && form}
          disabled={disabled && disabled}
          displayVal={displayVal}
        />
      </Box>
    ),
  };
  let render = skip ? (
    <SkipButton
      form={form}
      disabled={disabled}
      displayVal={displayVal}
      skipHandler={skipHandler}
    />
  ) : (
    buttons[hasNote]
  );
  return render;
};

export default SubmitButton;
